module.exports = __webpack_public_path__ + "static/localhealth-logo@3x-4e6080dfea5e87877accc52971d626a4.png";